import styled from "styled-components";

export const Layout = styled.div<{ color: string }>`
  width: 16px;
  height: 16px;
  color: ${props => props.color};

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const EmptyIcon = styled.div<{ color: string }>`
  width: 12px;
  height: 12px;
  border-radius: 3px;
  background-color: ${props => props.color};
`;
